import { render, staticRenderFns } from "./default-opt-in-form.vue?vue&type=template&id=2e2187c1&scoped=true&"
import script from "./default-opt-in-form.vue?vue&type=script&lang=js&"
export * from "./default-opt-in-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2187c1",
  null
  
)

export default component.exports